import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { useStyles } from "./InventoriesEmpty.style";
import {
  Button,
  Typography,
  TypographyColor,
  TypographyVariant,
} from "@onmo/ui";
import { useTranslation } from "react-i18next";

interface IInventoriesEmptyProps {
  type: "Owned" | "Bundles" | "Avatars";
  onGoToShop?: () => void;
}
export const InventoriesEmpty: FC<
  IInventoriesEmptyProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { type, onGoToShop, className, ...otherProps } = props;

  const firstTitle = (type: string) => {
    switch (type) {
      case "Owned":
        return t("you_don_t_own_any_avatars");
      case "Avatars":
        return t("you_have_bought_all_available_items");
      case "Bundles":
        return t("you_have_bought_all_available_items");
    }
  };

  const secondTitle = (type: string) => {
    switch (type) {
      case "Owned":
        return t("visit_shop_to_purchase_avatar_or_bundle");
      case "Bundles":
      case "Avatars":
        return t("please_check_back_soon_text");
    }
  };

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <Typography variant={TypographyVariant.BodyB2Bold}>
        {firstTitle(type)}
      </Typography>
      <Typography
        variant={TypographyVariant.BodyB5Regular}
        color={TypographyColor.Text2}
      >
        {secondTitle(type)}
      </Typography>
      {onGoToShop && (
        <Button size="small" className={classes.btnShop} onClick={onGoToShop}>
          {t("shop_now")}
        </Button>
      )}
    </div>
  );
};
